import React from "react";
import "./AboutTabContent.css";

const AboutTabwhyus = () => {
  return (
    <div className="about-tab-contents">
      <h2 className="about-tab-contents-h2">Why us</h2>
      <p className="about-tab-contents-p">
        Our company has quite a portfolio to boot . We ensure every detail is
        taken care of to ensure the task is not only accomplished but the
        accomplishment leaves all parties involved happy and satisfied Some of
        our past projects are on our portfolio page
      </p>
    </div>
  );
};

export default AboutTabwhyus;
